import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-square',
  templateUrl: './logo-square.component.html',
})
export class LogoSquareComponent implements OnInit {
  @Input()
  color: string;
  @Input()
  size: string;
  COLORS = {
    black: '#191919',
    'blue-900': '#023082',
    white: '#FFFFFF',
  };
  DEFAULT_COLOR = this.COLORS.white;
  SMALL_SIZE = 'small';
  displayColor: string;

  ngOnInit() {
    this.displayColor = (this.COLORS as any)[this.color] || this.color;
  }
}
